import * as React from 'react';
import { SVGProps, memo } from 'react';

/**
 * НЕ РЕДАКТИРОВАТЬ
 *
 * Этот файл создан автоматически с помощью svgr
 *
 * Подробнее, как работать с иконками:
 * @see https://lvtv.me/icons
 */
const SvgDropdownIconJoint = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="m13.5 11.005 4.5 2.786 4.5-2.786"
      stroke="#17181A"
      strokeLinecap="round"
    />
  </svg>
);
const Memo = memo(SvgDropdownIconJoint);
export default Memo;
